export const WellDesignPath = 'well-design';
